import { FC, ChangeEvent, useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { CopyWishlist, MoveWishlist } from '../WishlistToolbar'
import { WishlistManager } from '../Hooks/WishlistActionTypes'
import { Wishlist } from '@pylot-data/pylotschema'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import s from '@pagestyles/Wishlist.module.scss'
import cn from 'classnames'

export type Props = {
    wishlist: Wishlist
    wishlistManager: WishlistManager
}

export const WishlistToolbar: FC<Props> = ({ wishlist, wishlistManager }) => {
    const { t } = useTranslation(['wishlist'])
    const { wishlistState, addSelected, resetSelected } = wishlistManager
    const config = useStoreConfig()

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) {
            const ids = wishlist?.items_v2?.items?.map((item) => item?.id) as []
            addSelected(ids)
        } else {
            resetSelected()
        }
    }

    const canSelectAll = useMemo(() => {
        return wishlist?.items_v2?.items?.every((item) =>
            wishlistState?.selected?.includes(String(item?.id))
        )
    }, [wishlist, wishlistState])

    if (
        !config.base.wishlist.multiple_wishlists ||
        !wishlist?.items_v2?.items.length
    )
        return null

    return (
        <div className={s['wishlist-top-toolbar']}>
            <div className={s['checkbox-container']}>
                <label className="label" htmlFor="select_all">
                    <input
                        type="checkbox"
                        className={cn(s['form-checkbox'], 'form-checkbox')}
                        id="select_all"
                        onChange={handleChange}
                        checked={canSelectAll}
                    />
                    {t('wishlist|Select All')}
                </label>
            </div>
            <CopyWishlist
                wishlist={wishlist}
                wishlistState={wishlistState}
                dropDownLabel={t('wishlist|Copy Selected to Wish List')}
            />
            <MoveWishlist
                wishlist={wishlist}
                wishlistState={wishlistState}
                dropDownLabel={t('wishlist|Move Selected to Wish List')}
            />
        </div>
    )
}
